import React from 'react'
import { useState } from 'react'
import useStore from 'state/knovStore'
import cn from 'classnames'
import styles from 'components/quests/action.module.scss'
import useGetQuest from 'refactor/hooks/api/useGetQuest'
import usePanelContext from 'refactor/hooks/usePanelContext'
import ThinQuest, { Stream } from 'components/quests/ThinQuest'
import SearchIcon from 'components/shared/icons/SearchIcon'

export default function Action(props) {
    const debug = useStore(state => state.DEBUG)
    const [isHovering, setIsHovering] = useState(false)

    const { hide } = usePanelContext()

    const action = props.action
    const includedQuest = action.quest
    const { quest: fetchedQuest } = useGetQuest(includedQuest ? undefined : action.actionable_id)
    const quest = includedQuest || fetchedQuest

    return (
        <div
            className={cn(styles.actionComp)}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            style={{ visibility: hide ? 'hidden' : 'visible' }}
        >
            <div className={styles.flexContainer}>
                {quest ? (
                    <ThinQuest quest={quest} contextStyles={styles.thinQuest} showStream={true} />
                ) : (
                    <>
                        <Stream
                            team={action.team_from_filter}
                            user={action.user}
                            filter={action.meta?.filter}
                        />

                        <div className={cn(styles.actionPart)}>
                            <div className={cn(styles.iconContainer)}>
                                <span className={cn(styles.stackSearchIcon)}>
                                    <SearchIcon />
                                </span>
                            </div>

                            <div className={cn(styles.actionContentContainer)}>
                                <div className={cn(styles.actionName)}>{action.meta?.query}</div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}
